'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _initCustomNavFlickity = require('../helpers/initCustomNavFlickity');

var _initCustomNavFlickity2 = _interopRequireDefault(_initCustomNavFlickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components

// PDP Slider

document.addEventListener('DOMContentLoaded', function (event) {
  var fullwidthButtonsSlider = document.querySelectorAll('.fullwidth-buttons-slider__container');

  [].concat((0, _toConsumableArray3.default)(fullwidthButtonsSlider)).forEach(function (slider) {
    // Initialize the slider
    var sliderFlickity = (0, _initCustomNavFlickity2.default)(slider, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      adaptiveHeight: true
    });

    // Buttons
    var sliderButtons = slider.querySelectorAll('.fullwidth-buttons-slider__button');
    [].concat((0, _toConsumableArray3.default)(sliderButtons)).forEach(function (button, index) {
      button.addEventListener('mouseenter', function () {
        sliderFlickity.select(index);
      });
    });
  });
}); /*----------------------------
    Scripts
    ----------------------------*/

// Helpers